import React from 'react'

/* doc
---
title: CardFooter
name: CardFooter
category: React - Bulma
parent: Card
---

A `CardFooter` component for adding footer content to a `Card`.

Can mostly be used with the `CardFooterItem` components.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <Card>
    ...
    <CardFooter>
      <CardFooterItem>...</CardFooterItem>
      <CardFooterItem>...</CardFooterItem>
      <CardFooterItem>...</CardFooterItem>
    </CardFooter>
  </Card>
```
*/
function CardFooter(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-footer',
    className || '',
  ]

  return (
    <footer {...rest} className={classes.join(' ')}>
      {children}
    </footer>
  )
}

export default CardFooter
